export const allShaders: IShaders = {
  Standard: {
    id: 'Standard',
    name: 'Standard',
  },
  Toon: {
    id: 'Toon',
    name: 'Toon',
  },
  UVs: {
    id: 'UVs',
    name: 'UVs',
  },
} as IShaders;
